var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfDonutPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3053_36344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.117 20.2819V9.95129C14.9667 10.0661 10.0569 12.207 6.40491 15.9303C2.75289 19.6536 0.63857 24.674 0.5 29.9513H11.004C11.0151 27.4469 11.969 25.0436 13.6667 23.2422C15.3644 21.4408 17.675 20.3803 20.117 20.2819Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0605 24.1455L34.623 19.1455L36.2763 17.8955C34.4525 15.4784 32.1206 13.5135 29.4539 12.1471C26.7872 10.7807 23.8542 10.0478 20.873 10.0029V20.3335C22.2716 20.3849 23.6415 20.7535 24.8844 21.4126C26.1272 22.0718 27.2119 23.0051 28.0605 24.1455Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7298 18.5154L28.4939 24.7757C29.4733 26.3339 29.9915 28.1495 29.9858 30.003H40.4999C40.4083 25.8707 39.0935 21.8645 36.7298 18.5154Z",
    fill: "#0069D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_36344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5 0.00292969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfDonutPie);
export default __webpack_public_path__ + "static/media/half_donut_pie.84fc4d0a043881b11583de14a39e87bc.svg";
export { ForwardRef as ReactComponent };